<template>
  <div style="min-height: 750px;" v-if="d_usrWdm">
    <template>
      <b-row>
        <b-col sm="12" lg="2"></b-col>
        <b-col sm="12" lg="8"></b-col>
        <b-col sm="12" lg="2"></b-col>
      </b-row>
      <b-row style="margin-bottom: 20px; border-bottom: solid 1px whitesmoke;">
        <b-col sm="12" md="2" lg="2"> </b-col>
        <b-col sm="12" md="4" lg="4">
          <i class="fa fa-user-o"></i>
          {{ StoreLangTranslation.data['general_settings'][StoreLang] }}
        </b-col>
        <b-col sm="12" md="4" lg="4" :style="StoreDevice.isMobile ? '' : 'text-align: right;'"></b-col>
        <b-col sm="12" md="2" lg="2">
        </b-col>
      </b-row>
      <b-row style="font-size: 16px;">
        <b-col sm="12" lg="2"></b-col>
        <b-col sm="12" lg="8">
          <template v-if="d_frontendLoading">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </template>
          <template>
            <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
              <b-row>
                <b-col sm="12" lg="8">
                  <h6>
                    <i class="fa fa-calculator"></i>
                    {{ StoreLangTranslation.data['personal_settings'][StoreLang] }}
                  </h6>
                </b-col>
                <b-col sm="12" lg="4" style="text-align: right;"></b-col>
              </b-row>
            </b-card-header>
            <b-card-body>
              <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                <b-col sm="12" lg="4">
                  {{ d_usrWdm['0']['parameters']['37']['name']['translation'][StoreLang] }}
                </b-col>
                <b-col sm="12" lg="8">
                  <select required class="form-control" v-model="d_userData.user_type">
                    <option v-for="(op, op_index) in d_usrWdm['0']['parameters']['37'].options" :value="op.value">
                      {{ op.translation[StoreLang] }}
                    </option>
                  </select>
                </b-col>
              </b-row>
              <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                <b-col sm="12" lg="4">
                  {{ d_usrWdm['0']['parameters']['1']['name']['translation'][StoreLang] }}
                </b-col>
                <b-col sm="12" lg="8">
                  <b-form-input required type="text" v-model="d_userData.firstname"/>
                </b-col>
              </b-row>
              <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                <b-col sm="12" lg="4">
                  {{ d_usrWdm['0']['parameters']['2']['name']['translation'][StoreLang] }}
                </b-col>
                <b-col sm="12" lg="8">
                  <b-form-input required type="text" v-model="d_userData.lastname"/>
                </b-col>
              </b-row>
              <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                <b-col sm="12" lg="4">
                  {{ d_usrWdm['0']['parameters']['5']['name']['translation'][StoreLang] }}
                </b-col>
                <b-col sm="12" lg="8">
                  <select required class="form-control" v-model="d_userData.gender">
                    <option v-for="(op, op_index) in d_usrWdm['0']['parameters']['5'].options" :value="op.value">
                      {{ op.translation[StoreLang] }}
                    </option>
                  </select>
                </b-col>
              </b-row>
              <div style="border-bottom: solid 1px whitesmoke;">
                <b-row style="margin: 3px;">
                  <b-col sm="12" lg="4">
                    <strong>
                      {{ StoreLangTranslation.data['profile_picture'][StoreLang] }}
                    </strong>
                    <!-- <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('projects_excel_file', StoreLang)"> </i> -->
                  </b-col>
                  <b-col sm="12" lg="8">
                    <b-form-file
                      v-model="d_profilePictureFile"
                      accept=".png, .jpg, .jpeg, .ico"
                      ref="profilePictureInput"
                      @change="f_handleFileUpload"
                      :browse-text="StoreLangTranslation.data['select_file'][StoreLang]"
                      :placeholder="StoreLangTranslation.data['select_profile_picture'][StoreLang]"
                    ></b-form-file>
                  </b-col>
                  
                </b-row>

                <b-row v-if="d_imageSrc" style="margin: 3px;">
                  <b-col sm="12" lg="4">
                    <!-- profil doc: {{ d_userData['cover_photo'] }} -->
                    <img :src="d_imageSrc" style="width: 100%;" />
                  </b-col>
                </b-row>
              </div>

              <div style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                
                <b-row style="margin: 3px; margin-bottom: 10px;">
                  <b-col sm="12" lg="4">
                    <strong>
                      {{ d_usrWdm['0']['parameters']['21']['name']['translation'][StoreLang] }}
                    </strong>
                  </b-col>

                  <b-col sm="12" lg="8">
                    <button class="btn btn-success" @click="f_addAbout()">
                      +
                    </button>
                  </b-col>
                </b-row>

                <div v-for="(about_item, about_index) in d_userData.about_me" :key="'about_' + about_index">
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="2">
                      <button class="btn btn-danger" @click="f_removeAbout(about_index)">
                        <i class="fa fa-trash-o"></i>
                      </button>
                      <button class="btn btn-info" style="margin-left: 5px;" @click="f_copyAbout(about_index)">
                        <i class="fa fa-clone"></i>
                      </button>
                    </b-col>
                    <b-col sm="12" lg="2">
                      <strong>{{ d_usrWdm['0']['parameters']['21']['parameters']['22']['name']['translation'][StoreLang] }}</strong>
                    </b-col>
                    <b-col sm="12" lg="8">
                      <b-form-textarea
                        class="form-control"
                        v-model="about_item.note">
                      </b-form-textarea>
                    </b-col>
                  </b-row>
                </div>
              </div>
              <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                <b-col sm="12" lg="4">
                  {{ d_usrWdm['0']['parameters']['4']['name']['translation'][StoreLang] }}
                </b-col>
                <b-col sm="12" lg="8">
                  <b-form-datepicker 
                    v-model="d_datePickerDate" 
                    :locale="StoreLang" 
                    today-button
                    reset-button
                    close-button/>
                </b-col>
              </b-row>
              <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                <b-col sm="12" lg="4">
                  {{ d_usrWdm['0']['parameters']['13']['name']['translation'][StoreLang] }}
                </b-col>
                <b-col sm="12" lg="8">
                  <select required class="form-control" v-model="d_userData.active_lang">
                    <option v-for="(op, op_index) in d_usrWdm['0']['parameters']['13'].options" :value="op.value">
                      {{ op.translation[StoreLang] }}
                    </option>
                  </select>
                </b-col>
              </b-row>
            </b-card-body>


            <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
              <b-row>
                <b-col sm="12" lg="8">
                  <h6>
                    <i class="fa fa-phone"></i>
                    {{ StoreLangTranslation.data['contact_settings'][StoreLang] }}
                  </h6>
                </b-col>
                <b-col sm="12" lg="4" style="text-align: right;"></b-col>
              </b-row>
            </b-card-header>
            <b-card-body>
              <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                <b-col sm="12" lg="4">
                  {{ d_usrWdm['0']['parameters']['49']['name']['translation'][StoreLang] }}
                </b-col>
                <b-col sm="12" lg="8">
                  <b-button @click="f_addNewMail()" variant="outline-primary" style="margin-bottom: 10px;" :disabled="d_mailListLoading">
                    {{ StoreLangTranslation.data['add'][StoreLang] }}
                  </b-button>
                  <template v-for="mail_item in d_userData.mail_list">
                    <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                      <b-col sm="12" lg="8">
                        {{ mail_item.mail }}
                      </b-col>
                      <b-col sm="12" lg="4">
                        <span :style="mail_item.mail_approve_status == '1' ? 'color: green;' : 'color: red;'">
                          {{ d_usrWdm['0']['parameters']['49']['parameters']['50']['options'][mail_item.mail_approve_status]['translation'][StoreLang] }}
                        </span>
                      </b-col>
                    </b-row>
                  </template>

                  <template v-for="(new_mail_item, new_mail_item_index) in d_newMailList">
                    <b-row>
                      <b-col sm="12" lg="11">
                        <b-form-input v-model="new_mail_item.mail"></b-form-input>
                      </b-col>
                      <b-col sm="12" lg="1">
                        <b-button @click="f_removeNewMail(new_mail_item_index)" variant="outline-danger" :disabled="d_mailListLoading">
                          <i class="fa fa-trash"></i>
                        </b-button>
                      </b-col>
                    </b-row>
                    <hr style="margin: 5px 0px" />
                  </template>
                  <template v-if="d_newMailList.length > 0">
                    <b-row>
                      <b-col lg="4" sm="12">
                        <b-button @click="f_saveNewMail()" variant="outline-success" style="margin-bottom: 10px; width: 100%;" :disabled="d_mailListLoading">
                          <b-spinner v-if="d_mailListLoading" variant="primary" label="Spinning" style="width: 20px; height: 20px;"></b-spinner>
                          <span v-else>
                            {{ StoreLangTranslation.data['save'][StoreLang] }}
                          </span>
                        </b-button>
                      </b-col>
                    </b-row>
                  </template>

                </b-col>
              </b-row>

              <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                <b-col sm="12" lg="4">
                  {{ d_usrWdm['0']['parameters']['24']['name']['translation'][StoreLang] }}
                </b-col>
                <b-col sm="12" lg="8">
                  <b-textarea rows="5" v-model="d_userData.address"></b-textarea>
                </b-col>
              </b-row>
              <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                <b-col sm="12" lg="4">
                  {{ d_usrWdm['0']['parameters']['25']['name']['translation'][StoreLang] }}
                </b-col>
                <b-col sm="12" lg="8">
                  <b-form-input type="number" v-model="d_userData.phone_number"/>
                </b-col>
              </b-row>
              <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                <b-col sm="12" lg="4">
                  {{ d_usrWdm['0']['parameters']['27']['name']['translation'][StoreLang] }}
                </b-col>
                <b-col sm="12" lg="8">
                  <b-form-input type="number" v-model="d_userData.phone_area_code"/>
                </b-col>
              </b-row>
              <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                <b-col sm="12" lg="4">
                  {{ d_usrWdm['0']['parameters']['41']['name']['translation'][StoreLang] }}
                </b-col>
                <b-col sm="12" lg="8">
                  <select required class="form-control" v-model="d_userData.campaign_notifications">
                    <option v-for="(op, op_index) in d_usrWdm['0']['parameters']['41'].options" :value="op.value">
                      {{ op.translation[StoreLang] }}
                    </option>
                  </select>
                </b-col>
              </b-row>
              <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                <b-col sm="12" lg="4">
                  {{ d_usrWdm['0']['parameters']['47']['name']['translation'][StoreLang] }}
                </b-col>
                <b-col sm="12" lg="8">
                  <select required class="form-control" v-model="d_userData.user_profile_show_status">
                    <option v-for="(op, op_index) in d_usrWdm['0']['parameters']['47'].options" :value="op.value">
                      {{ op.translation[StoreLang] }}
                    </option>
                  </select>
                </b-col>
              </b-row>
              <template v-if="d_userData.user_profile_show_status == '1'">
                <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                  <b-col sm="12" lg="4">
                    {{ d_usrWdm['0']['parameters']['53']['name']['translation'][StoreLang] }}
                  </b-col>
                  <b-col sm="12" lg="8">
                    <select required class="form-control" v-model="d_userData.user_mail_show_status">
                      <option v-for="(op, op_index) in d_usrWdm['0']['parameters']['53'].options" :value="op.value">
                        {{ op.translation[StoreLang] }}
                      </option>
                    </select>
                  </b-col>
                </b-row>
                <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                  <b-col sm="12" lg="4">
                    {{ d_usrWdm['0']['parameters']['54']['name']['translation'][StoreLang] }}
                  </b-col>
                  <b-col sm="12" lg="8">
                    <select required class="form-control" v-model="d_userData.user_phone_show_status">
                      <option v-for="(op, op_index) in d_usrWdm['0']['parameters']['54'].options" :value="op.value">
                        {{ op.translation[StoreLang] }}
                      </option>
                    </select>
                  </b-col>
                </b-row>
              </template>
            </b-card-body>

            <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
              <b-row>
                <b-col sm="12" lg="8">
                  <h6>
                    <i class="fa fa-file-text-o"></i>
                    {{ StoreLangTranslation.data['bill_settings'][StoreLang] }}
                  </h6>
                </b-col>
                <b-col sm="12" lg="4" style="text-align: right;"></b-col>
              </b-row>
            </b-card-header>
            <b-card-body>
              <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                <b-col sm="12" lg="4">
                  {{ d_usrWdm['0']['parameters']['38']['name']['translation'][StoreLang] }}
                </b-col>
                <b-col sm="12" lg="8">
                  <b-form-input type="text" v-model="d_userData.bill_agreement_name"/>
                </b-col>
              </b-row>
              <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                <b-col sm="12" lg="4">
                  {{ d_usrWdm['0']['parameters']['39']['name']['translation'][StoreLang] }}
                </b-col>
                <b-col sm="12" lg="8">
                  <b-form-input type="text" v-model="d_userData.tax_number"/>
                </b-col>
              </b-row>
              <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                <b-col sm="12" lg="4">
                  {{ d_usrWdm['0']['parameters']['40']['name']['translation'][StoreLang] }}
                </b-col>
                <b-col sm="12" lg="8">
                  <b-form-input type="text" v-model="d_userData.tax_office"/>
                </b-col>
              </b-row>
            </b-card-body>

            <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
              <b-row>
                <b-col sm="12" lg="8">
                  <h6>
                    <i class="fa fa-mobile-phone"></i>
                    {{ StoreLangTranslation.data['social_media_settings'][StoreLang] }}
                  </h6>
                </b-col>
                <b-col sm="12" lg="4" style="text-align: right;"></b-col>
              </b-row>
            </b-card-header>
            <b-card-body>
              <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                <b-col sm="12" lg="4">
                  {{ d_usrWdm['0']['parameters']['14']['name']['translation'][StoreLang] }}
                </b-col>
                <b-col sm="12" lg="8">
                  <b-form-input type="text" v-model="d_userData.facebook"/>
                </b-col>
              </b-row>
              <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                <b-col sm="12" lg="4">
                  {{ d_usrWdm['0']['parameters']['15']['name']['translation'][StoreLang] }}
                </b-col>
                <b-col sm="12" lg="8">
                  <b-form-input type="text" v-model="d_userData.instagram"/>
                </b-col>
              </b-row>
              <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                <b-col sm="12" lg="4">
                  {{ d_usrWdm['0']['parameters']['16']['name']['translation'][StoreLang] }}
                </b-col>
                <b-col sm="12" lg="8">
                  <b-form-input type="text" v-model="d_userData.linkedin"/>
                </b-col>
              </b-row>
              <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                <b-col sm="12" lg="4">
                  {{ d_usrWdm['0']['parameters']['17']['name']['translation'][StoreLang] }}
                </b-col>
                <b-col sm="12" lg="8">
                  <b-form-input type="text" v-model="d_userData.twitter"/>
                </b-col>
              </b-row>
              <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                <b-col sm="12" lg="4">
                  {{ d_usrWdm['0']['parameters']['18']['name']['translation'][StoreLang] }}
                </b-col>
                <b-col sm="12" lg="8">
                  <b-form-input type="text" v-model="d_userData.website"/>
                </b-col>
              </b-row>
              <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                <b-col sm="12" lg="4">
                  {{ d_usrWdm['0']['parameters']['19']['name']['translation'][StoreLang] }}
                </b-col>
                <b-col sm="12" lg="8">
                  <b-form-input type="text" v-model="d_userData.youtube"/>
                </b-col>
              </b-row>
            </b-card-body>


            <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
              <b-row>
                <b-col sm="12" lg="8">
                  <h6>
                    <i class="fa fa-lock"></i>
                    {{ StoreLangTranslation.data['security_settings'][StoreLang] }}
                  </h6>
                </b-col>
                <b-col sm="12" lg="4" style="text-align: right;"></b-col>
              </b-row>
            </b-card-header>
            <b-card-body>
              <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                <b-col sm="12" lg="4">
                  {{ d_usrWdm['0']['parameters']['36']['name']['translation'][StoreLang] }}
                </b-col>
                <b-col sm="12" lg="8">
                  <select required class="form-control" v-model="d_userData.two_factor_authentication">
                    <option v-for="(op, op_index) in d_usrWdm['0']['parameters']['36'].options" :value="op.value">
                      {{ op.translation[StoreLang] }}
                    </option>
                  </select>
                </b-col>
              </b-row>
              <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                <b-col sm="12" lg="12">
                  <b-row style="padding: 3px;">
                    <b-col cols="5" style="padding-left: 15px; padding-top: 0px; text-align: left">
                      {{ StoreLangTranslation.data['password'][StoreLang] }}
                    </b-col>
                    <b-col cols="7" style="padding-left: 15px; padding-top: 0px; text-align: left">
                      <span @click="f_generateRandomPassword()" style="padding-left: 15px; cursor: pointer; text-decoration: underline; font-style: italic;">
                      {{ StoreLangTranslation.data['password_create'][StoreLang] }}
                      </span>
                      <b-input-group label-for="password" label-cols="6" validated>
                        <b-form-input :type="d_showPasswordType" class="form-control-warning" id="password" key="password" v-model="d_userData.password" :state="f_checkPasswordFilled()"></b-form-input>
                        <b-input-group-append>
                          <b-input-group-text style="cursor: pointer;" @click="f_showPasswordType()">
                            <i class="fa fa-eye"></i>
                          </b-input-group-text>
                        </b-input-group-append>
                        <b-form-valid-feedback></b-form-valid-feedback>
                        <b-form-invalid-feedback>
                          {{ StoreLangTranslation.data['password_minimum_sixteen_characters'][StoreLang] }}
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </b-col>
                  </b-row>
                  <b-row style="padding: 3px;">
                    <b-col cols="5" style="padding-left: 15px; padding-top: 0px; text-align: left">
                      {{ StoreLangTranslation.data['password_retype'][StoreLang] }}
                    </b-col>
                    <b-col cols="7" style="padding-left: 15px; padding-top: 0px; text-align: left">
                      <b-form-input :type="d_showPasswordType" class="form-control-warning" id="d_passwordRepeat" key="d_passwordRepeat" v-model="d_passwordRepeat" :state="f_checkPasswordFilled()"></b-form-input>
                      <b-form-valid-feedback></b-form-valid-feedback>
                      <b-form-invalid-feedback>
                        {{ StoreLangTranslation.data['password_minimum_sixteen_characters'][StoreLang] }}
                      </b-form-invalid-feedback>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-card-body>
            <b-button @click="f_userRecord()" variant="outline-primary" style="float: right;">
              <i class="fa fa-save"></i>
              {{ StoreLangTranslation.data['save'][StoreLang] }}
            </b-button>

          </template>
        </b-col>
        <b-col sm="12" lg="2"></b-col>
      </b-row>
    </template>
  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';

import { API_BASE_URL } from '@/config';
import { ServiceFunctions } from '@/wam/modules/service';
import { ClsWdm } from '@/wam/modules/wdm';
import { WisdomRegex } from '@/public/WisdomRegex';
import store from '@/store';
import {
  default as Page404
} from '@/wam/components/widgets/Page404';
import {
  default as Login
} from '@/wam/views/login';
import { mapGetters } from 'vuex';
export default {
  name: 'user_settings',
  computed: mapGetters({
    StoreDevice: 'StoreDevice',
    StoreFrontendSettings: 'StoreFrontendSettings',
    StoreLang: 'StoreLang',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreMenuData: 'StoreMenuData',
    StoreLangList: 'StoreLangList',
  }),
    components: {
    Page404,
    Login,
  },
  props: {},
  data () {
    return {
      // d_editParameter: '',
      // d_systemDocumentList: [],
      // d_imageUploadModal: false,
      // d_fullScreen: false,
      // d_tmpFile: null,
      d_showPassword: {
        'mail_smtp_password': false,
        'worganization_api_username': false,
        'worganization_api_password': false,
        'worganization_token': false,
        'register_mail_approve_mail_from_password': false,
        'mail_api_token_username': false,
        'mail_api_token_password': false,
        'waccount_password': false,
        'support_mail_from_password': false,
      },
      d_usrWdm: '',
      d_userData: {
        'status': '',
        'firstname': '',
        'lastname': '',
        'username': '',
        'date_of_birth': '',
        'gender': '',
        'eula_approve_status': '',
        'eula_approve_date': '',
        'eula_document_code': '',
        'mail_approve_status': '',
        'mail_approve_token': '',
        'mail': '',
        'cover_photo': '',
        'active_lang': '',
        'facebook': '',
        'instagram': '',
        'linkedin': '',
        'twitter': '',
        'website': '',
        'youtube': '',
        'hashed_password': '',
        'about_me': [],
        'note': '',
        'phone_number_approve_status': '',
        'address': '',
        'phone_number': '',
        'phone_number_approve_token': '',
        'phone_area_code': '',
        'create_date': '',
        'mail_password_reset_token': '',
        'password_reset_date': '',
        'password_reset_status': '',
        'password': '',
        'two_factor_authentication': '',
        'campaign_notifications': '',
        'user_type': '',
        'bill_agreement_name': '',
        'tax_number': '',
        'tax_office': '',
        'institution': '',
        'country': '',
        'city': '',
        'zip_code': '',
        'orcid_id': '',
        'user_profile_show_status': '',
        'mail_list': [],
        'user_mail_show_status': '',
        'user_phone_show_status': '',
      },
      d_datePickerDate: '',
      d_user: '',
      d_pageShow: false,
      d_page404Show: false,
      d_frontendLoading: false,
      d_showPasswordType: "password",
      d_passwordRepeat: '',
      d_newMailList: [],
      d_mailListLoading: false,
      d_profilePictureFile: null,
      d_profilePictureFileBase64: '',
      d_profilePictureFileName: '',
      d_profilePicturefileExtension: '',
      d_docLoading: true,
      d_imageSrc: '',
    };
  },
  created: function () {
    ClsWdm.getLayerWdm('usr').then(resp_wdm_data => { this.d_usrWdm = resp_wdm_data; });
    this.d_user = JSON.parse(localStorage.getItem('user'));
    if (this.StoreFrontendSettings.data.login_function_external === '1') {
      // login ekranından uzaklaşmamak ve account sayfasına gitmemesi için test süreçlerine alttaki satır kapatılabilir.
      this.f_waccountLogin();
    } else {
      this.f_getUserSettings();
    }
    // this.f_langEligibleParameterProcess();
    // this.d_frontendData = JSON.parse(JSON.stringify(this.StoreFrontendSettings.data));
    // console.log('this.d_frontendData.menu_type', this.d_frontendData.menu_type);
    // console.log(JSON.stringify(this.d_frontendData));
    
    
  },
  beforeMount () {},
  mounted: function () {},
  methods: {
    f_profileDocUpdate: function () {
      this.d_docLoading = true;
      let query = 'user_client_id=' + this.d_user.username;
      query += '&file_path=profile_picture';
      // query += '&layer_client_id=';
      query += '&layer_code=usr';
      if (this.d_user['cover_photo']) {
        query += '&doc_id=' + this.d_user['cover_photo'];
      }
      let data = {
        'file': this.d_profilePictureFileBase64,
        'file_type': this.d_profilePicturefileExtension,
      };
      ServiceFunctions.document_record_to_db(query, data)
        .then(resp_record => {
          this.d_docLoading = false;
          if (resp_record.data.status_code.substring(resp_record.data.status_code.length - 3, resp_record.data.status_code.length) == '000') {
            if (resp_record.data.doc_id) {
              // 'pdf_doc_id'
              this.d_userData['cover_photo'] = resp_record.data.doc_id;
              this.d_imageSrc = this.d_profilePictureFileBase64;
            }

          } else {
            let txt = 'status_code = ' + resp_record.data.status_code + '\n';
            txt += 'status_message = ' + resp_record.data.status_message;
            alert(txt);
          }
        });
    },
    f_handleFileUpload: function (event) {
      const file = event.target.files[0];
      if (file) {
        if (file.name.endsWith('.png') || file.name.endsWith('.jpg') || file.name.endsWith('.jpeg') || file.name.endsWith('.ico')) {
          const max_size_bytes = 1024 * 1024;
          if (file.size > max_size_bytes) {
            alert(this.StoreLangTranslation.data['file_size_is_not_eligible'][this.StoreLang] + ' (max 1mb)');
            this.d_profilePictureFile = null;
            this.d_profilePictureFileBase64 = '';
            this.d_profilePictureFileName = '';
            this.d_profilePicturefileExtension = '';
            this.$refs.profilePictureInput.reset();
          } else {
            this.d_profilePictureFileName = file.name;
            let arr = file.name.split('.');
            this.d_profilePicturefileExtension = arr[arr.length - 1];

            var vm = this;
            var reader = new FileReader();
            reader.addEventListener('load', function () {
              vm.d_profilePictureFileBase64 = reader.result;
              vm.$forceUpdate();
              vm.f_profileDocUpdate();
            }, false);
            reader.readAsDataURL(file);
          }

        } else {
          this.d_profilePictureFile = null;
          this.d_profilePictureFileBase64 = '';
          this.d_profilePictureFileName = '';
          this.d_profilePicturefileExtension = '';
          this.$refs.profilePictureInput.reset();
          this.$bvToast.toast(this.StoreLangTranslation.data['upload_only_excel_file'][this.StoreLang], {
            title: this.StoreLangTranslation.data['invalid_file_type'][this.StoreLang],
            variant: 'danger',
            solid: true,
          });
        }

      } else {
        this.d_profilePictureFileName = '';
      }
    },
    f_removeAbout: function (index) {
      if (confirm(this.StoreLangTranslation.data['delete_confirm'][this.StoreLang])) {
        this.d_userData.about_me.splice(index, 1);
      }
    },
    f_copyAbout: function (index) {
      let copy_about_note = JSON.parse(JSON.stringify(this.d_userData.about_me[index]))
      this.d_userData.about_me.push(copy_about_note);
    },

    f_addAbout: function () {
      this.d_userData.about_me.push({
        'note': "",
      });
    },


    f_addNewMail: function () {
      let new_data_mail = {
        'mail': ''
      };
      this.d_newMailList.push(new_data_mail);
    },
    f_removeNewMail: function (index) {
      if (confirm(this.StoreLangTranslation.data['delete_confirm'][this.StoreLang])) {
        this.d_newMailList.splice(index, 1);
      }
    },
    f_saveNewMail: function () {
      let query = 'user_client_id=' + this.d_user.username;
      let data = {
        'mail_list': this.d_newMailList, 
      };
      this.d_mailListLoading = true;
      ServiceFunctions.user_mail_add(query, data)
        .then(resp => {
          this.d_mailListLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            alert(this.StoreLangTranslation.data['mail_add_completed'][this.StoreLang]);
            for (let mail_item of this.d_newMailList) {
              this.d_userData.mail_list.push({
                'mail': mail_item.mail,
                'mail_approve_status': '0',
              })
            }
            this.d_newMailList = [];
            // if (resp.data.list && resp.data.list.length > 0) {
            //   this.d_bundleHasAgreementList = resp.data.list;
            // } else {
            //   alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            // }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    // f_langEligibleParameterProcess: function () {
    //   let lang_eligible_variables = ['firstname', 'lastname', 'date_of_birth', 'cover_photo', 'facebook', 'instagram', 'linkedin', 'twitter', 'website', 'youtube', 'address', 'phone_number', 'phone_area_code'];
    //   for (let k in lang_eligible_variables) {
    //     for (let lang_index in this.StoreLangList.data) {
    //       if (!this.d_userData[lang_eligible_variables[k]][this.StoreLangList.data[lang_index].label]) {
    //         this.d_userData[lang_eligible_variables[k]][this.StoreLangList.data[lang_index].label] = '';
    //       }
    //     }
    //   }
    // },
    f_getRedirectDashboardRoute: function () {
      let redirect_dashboard_path = '';
      for (let lang_index in lang_list) {
        let lang_label = lang_list[lang_index]['label'];
        for (let i in this.StoreMenuData.data.list) {
          let is_dashboard = '';
          try {
            is_dashboard = this.StoreMenuData.data.list[i].is_dashboard['value'];
          } catch (err) {}
          if (is_dashboard === '1') {
            let route_path = '';
            try {
              route_path = this.StoreMenuData.data.list[i].route_path[lang_label];
            } catch (err) {}
            if (route_path) {
              redirect_dashboard_path = route_path;
              break;
            }
          }
          if (this.StoreMenuData.data.list[i].list && this.StoreMenuData.data.list[i].list.length > 0) {
            for (let sub_i in this.StoreMenuData.data.list[i].list) {
              let is_dashboard = '';
              try {
                is_dashboard = this.StoreMenuData.data.list[i].list[sub_i].is_dashboard['value'];
              } catch (err) {}
              if (is_dashboard === '1') {
                let route_path = '';
                try {
                  route_path = this.StoreMenuData.data.list[i].list[sub_i].route_path[lang_label];
                } catch (err) {}
                if (route_path) {
                  redirect_dashboard_path = route_path;
                  break;
                }
              }

            }
          }
        }
      }
      // console.log('this.StoreMenuData ', this.StoreMenuData);
      // console.log('redirect_dashboard_path : ', redirect_dashboard_path);
      return redirect_dashboard_path;
    },
    f_goToMainPage: function () {
      let redirect_dashboard_path = this.f_getRedirectDashboardRoute();
      // console.log('redirect_dashboard_path : ', redirect_dashboard_path);
      if (redirect_dashboard_path[0] !== '/') {
        redirect_dashboard_path = '/' + redirect_dashboard_path;
      }

      this.$router.push({ path: redirect_dashboard_path, query: {} });
    },
    f_waccountLogin: function () {
      /*
        console.log(window);
        console.log(window.location.href);
      */
      // http://localhost:9001/#/login?external_application=8d9fde8c-3538-4516-b1ad-9e3b66c693dd&external_query=http://localhost:9001%2F%23%2Flogin
      if (confirm(this.StoreLangTranslation.data['directed_to_waccount'][this.StoreLang])) {
        let url = 'https://account.wisdomera.io/login';
        window.open(url, '_self');
      } else {
        this.f_goToMainPage();
      }
    },
    f_generateRandomPassword: function () {
      var length = 16,
        charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ",
        charsetSymbol = "!?.+&#",
        retVal = "";
      for (var i = 0; i < 14; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * charset.length));
      }
      for (var i = 0; i < 2; ++i) {
        retVal += charsetSymbol.charAt(Math.floor(Math.random() * charsetSymbol.length));
      }
      this.d_userData.password = retVal;
      this.d_passwordRepeat = retVal;
    },
    f_checkPasswordFilled: function () {
      if (this.d_passwordRepeat === this.d_userData.password && this.d_passwordRepeat.length >= 16) {
        let status = WisdomRegex.password(this.d_userData.password).status;
        return status;
      }
      return false;
    },
    f_showPasswordType: function () {
      if (this.d_showPasswordType === 'password') {
        this.d_showPasswordType = 'text';
      } else {
        this.d_showPasswordType = 'password';
      }
    },
    f_userRecord: function () {
      if(this.d_userData.firstname !== "" && this.d_userData.lastname !== "" && this.d_userData.gender !== "" && this.d_userData.active_lang !== "" && this.d_userData.date_of_birth !== ""){
        let query = '';
        let data = {
          user_data: {
            'firstname': this.d_userData.firstname,
            'lastname': this.d_userData.lastname,
            'date_of_birth': this.d_userData.date_of_birth,
            'gender': this.d_userData.gender,
            'cover_photo': this.d_userData.cover_photo,
            'active_lang': this.d_userData.active_lang,
            'facebook': this.d_userData.facebook,
            'instagram': this.d_userData.instagram,
            'linkedin': this.d_userData.linkedin,
            'twitter': this.d_userData.twitter,
            'website': this.d_userData.website,
            'youtube': this.d_userData.youtube,
            'address': this.d_userData.address,
            'phone_number': this.d_userData.phone_number,
            'phone_area_code': this.d_userData.phone_area_code,
            'password': this.d_userData.password,
            'two_factor_authentication': this.d_userData.two_factor_authentication,
            'campaign_notifications': this.d_userData.campaign_notifications,
            'user_type': this.d_userData.user_type,
            'bill_agreement_name': this.d_userData.bill_agreement_name,
            'tax_number': this.d_userData.tax_number,
            'tax_office': this.d_userData.tax_office,
            'institution': this.d_userData.institution,
            'country': this.d_userData.country,
            'city': this.d_userData.city,
            'zip_code': this.d_userData.zip_code,
            'orcid_id': this.d_userData.orcid_id,
            'user_profile_show_status': this.d_userData.user_profile_show_status,
            'user_mail_show_status': this.d_userData.user_mail_show_status,
            'user_phone_show_status': this.d_userData.user_phone_show_status,
            'about_me': this.d_userData.about_me,
          }
        };
        ServiceFunctions.user_record(query, data)
          .then(resp => {
            // console.log("resp.data")
            // console.log(resp.data)
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              alert(this.StoreLangTranslation.data['update_success_message'][this.StoreLang]);
            } else {
              alert(resp.data.status_code + ' = ' + resp.data.status_message);
            }
          });
        } else {
          alert(this.StoreLangTranslation.data['empty_input_message'][this.StoreLang] + 
            '\n-' + this.d_usrWdm['0']['parameters']['1']['name']['translation'][this.StoreLang] +
            '\n-' + this.d_usrWdm['0']['parameters']['2']['name']['translation'][this.StoreLang] +
            '\n-' + this.d_usrWdm['0']['parameters']['4']['name']['translation'][this.StoreLang] +
            '\n-' + this.d_usrWdm['0']['parameters']['5']['name']['translation'][this.StoreLang] +
            '\n-' + this.d_usrWdm['0']['parameters']['13']['name']['translation'][this.StoreLang]
            );
        }
      
    },
    f_getUserSettings: function () {
      let query = '';
      let data = {};
      this.d_frontendLoading = true;
      ServiceFunctions.user_get(query, data)
        .then(resp => {
          this.d_frontendLoading = false;
          // console.log("resp.data")
          // console.log(resp.data)
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.d_userData = resp.data.user;
            this.f_setDatepickerDateOfBirth();
            if (this.d_userData['cover_photo']) {
              this.f_getProfileDoc(this.d_userData['cover_photo']);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_getProfileDoc: function (document_id) {
      let query = 'user_client_id=' + this.d_user['username'];
      query += '&document_id=' + document_id;
      let data = {};
      ServiceFunctions.document_get_from_db(query, data)
        .then(resp => {
          if (resp.data.doc && resp.data.doc_extension) {
            this.d_imageSrc = 'data:image/' + resp.data.doc_extension + ';base64,' + resp.data.doc
          } else {
            let txt = 'status_code = ' + resp.data.status_code + '\n';
            txt += 'status_message = ' + resp.data.status_message;
            alert(txt);
          }
        });
    },
    f_setDatepickerDateOfBirth: function() {
      if (this.d_userData.date_of_birth) {
        const [day, month, year] = this.d_userData.date_of_birth.split(".");
        // this.d_userData.date_of_birth = `${day}.${month}.${year}`;
        this.d_datePickerDate = year + '-' + month + '-' + day;
      } else {
        this.d_datePickerDate = "";
      }
    }
  },
  watch:{
    'd_datePickerDate': function() {
      if (this.d_datePickerDate) {
        const [year, month, day] = this.d_datePickerDate.split("-");
        // this.d_userData.date_of_birth = `${day}.${month}.${year}`;
        this.d_userData.date_of_birth = day + '.' + month + '.' + year;
      } else {
        this.d_userData.date_of_birth = "";
      }
    }
  }

}

</script>

